module.exports = __webpack_public_path__ + "static/Coco-da0c3ebe7ce7a4bd0e3c9c2f3030dc42.png";